export default {
	methods: {
		s3url: function(key, width) {
			if(key == null || key == '') {
				return '';
			}

			width = (typeof width !== 'undefined') ?  width : 'original';

			// fallback - if old format, get key from url
			if(key.indexOf('https://') !== -1) {
				// check old bug where key is undefined
				var bugStr = '_undefined';
				if(key.slice(-bugStr.length) === bugStr) {
					return key;
				}
				key = key.substr(key.lastIndexOf('/') + 1);
			}

			// get correct size
			var sizes = {
				'small': '300/',
				'medium': '1000/',
				'big': '1300/',
				'original': ''
			};
			var widthInPx = '';
			if(sizes.hasOwnProperty(width)) {
				widthInPx = sizes[width];
			}

			return 'https://d3acvr808w2me4.cloudfront.net/' + widthInPx + key;
		},
		/* FORMAT CURRENCY */
		formatCurrency: function(val) {
			if(val === '' || val === 0 || isNaN(val) || val === undefined) {
				return '--';
			}
			var price = parseInt(val);
			if(price >= 1E6 && price % 1E4 === 0) {
				return '£' + (price/1E6).toFixed(2).replace(/0+$/, '').replace(/\.$/, '') + 'm';
			} else if(price >= 1E3 && price % 1E2 === 0) {
				return '£' + (price/1E3).toFixed(1).replace(/0+$/, '').replace(/\.$/, '') + 'k';
			} else {
				return this.formatCurrencyFull(val);
			}
		},
		formatCurrencyFull: function(val) {
			if(val === '' || val === 0 || isNaN(val) || val === undefined) {
				return '';
			}
			var price = parseInt(val);
			return '£' + price.toFixed(0).replace(/(\d)(?=(\d{3})+$)/g, '$1,');
		},

		/* PROPERTY ADDRESS */
		propertyAddress: function(property) {
			var address = '';
			if(!property.address) {
				return address;
			}
			if(property.address.flatNumber) {
				address += property.address.flatNumber + ', ';
			}
			if(property.address.buildingNumber) {
				address += property.address.buildingNumber + ' ';
			}
			address += property.address.street;
			return address;
		},

		/* PROPERTY SUMMARY */
		propertySummary: function(property) {
			var summary = '';
			summary += this.formatCurrency(property.price);
			if (property.serviceTypeId === 2) {
				summary += ' ' + property.rentFrequency;
			}

			if(property.bedrooms == 0) {
				summary += ' Studio';
			} else {
				summary += ' ' + property.bedrooms;
				summary += property.bedrooms == 1 ? ' bedroom' : ' bedrooms';
			}
                                       if (property.bedrooms !== 0) {
			     summary += ' ' + this.propertySubtypeName(property.subtypeId);
                                       }
			return summary;
		},

		propertyBedsAndPrice: function(property) {
			var summary = ''

			if(property.bedrooms == 0) {
				summary += 'Studio';
			} else {
				summary += property.bedrooms;
				summary += property.bedrooms == 1 ? ' bedroom\n' : ' bedrooms\n';
			}

			summary += ' ' + this.formatCurrency(property.price);

			if (property.serviceType === 'lettings') {
				 summary += ' ' + property.rentFrequency;
			}

			return summary
		},

		/* PROPERTY TYPE NAME */
		propertyTypeName: function(typeId) {
            if(typeId == 'house') {
					return 'House';
				}
				if(typeId == 'flat') {
					return 'Flat';
				}
				return '';
		},

		/* PROPERTY SUBTYPE NAME */
		propertySubtypeName: function(subtypeId) {
            var propertySubtype = this.propertySubtypes.find(function(element) {
                return element.id == subtypeId;
            });
            return typeof propertySubtype !== 'undefined' ? propertySubtype.title : '';
		},

        /* PROPERTY STATUS NAME */
        propertyStatusName: function(statusId) {
            var status = this.propertyStatus.find(function(element) {
                return element.id == statusId;
            });
            return typeof status !== 'undefined' ? status.title : '';
        },

		addAllItemsToArray: function(items, array) {
			items.forEach(function(item) {
				array.push(item.id)
			})
			return array
		},

		getIdFromName: function(name, array) {
			var element = array.find(function(element) {
				 return element.name === name;
			});
			return typeof element !== 'undefined' ? element.id : 0;
		},
		getIdOrDefaultId: function(id, array) {
			var element = array.find(function(element) {
				 return element.id === id;
			});
			return typeof element !== 'undefined' ? element.id : array[0].id;
		},
		// For the View/Edit pages
		editView: function(isEditView) {
			var items = document.querySelectorAll( '.editable-item:not(.editable-item--enabled)')
			if (isEditView) {
				items.forEach(function(item) {
					item.classList.add('text-inactive');
				})
			} else {
				items.forEach(function(item) {
					item.classList.remove('text-inactive');
				})
			}
		}
	}
}
